import type {AxiosInstance} from 'axios';
import type VueRouter from 'vue-router';
import AxiosStatic from 'axios';
import {useUserStore} from '@/stores/user';
import {checkAndGetUserInfo, getPrincipalDetail} from '@/utils/check';

export function useInterceptors(axios: AxiosInstance, router: VueRouter) {
// http response 服务器响应拦截器，这里拦截401错误，并重新跳入登页
    axios
        .interceptors
        .response
        .use(
            response => response,
            error => {
                if (AxiosStatic.isAxiosError(error) && error.response) {
                    switch (error.response.status) {
                        case 401:
                            router.replace({
                                path: '/login',
                                query: {redirect: router.currentRoute.path},
                            });
                            break;
                        // case 403:
                        // 403为权限不足,这时用户已经登录,不能返回登录页,如果后台在为登录时返回403就是后台错了
                        // router.replace({
                        //     path: '/login',
                        //     query: {redirect: router.currentRoute.path},
                        // });
                        // break;
                        default:
                            if (
                                error.response?.request?.responseURL?.includes('api/waterloo/check')
                                || error.response?.request?.responseURL?.includes('authox/curUser')
                            ) {
                                router.replace({
                                    path: '/login',
                                    query: {redirect: router.currentRoute.path},
                                });
                            }
                    }
                }
                return Promise.reject(error);
            },
        );
    router.beforeEach(async (to, from, next) => {
        const $userStore = useUserStore();
        // 登录或者meta中auth为false则直接进入页面
        if (to.name === 'login' || to.meta?.auth === false) {
            next();
        } else {
            try {
                // 这个是假的
                const data=await checkAndGetUserInfo()
                $userStore.setUserInfo(data);
                if (data?.principalId) {
                    const principal = await getPrincipalDetail(data.principalId)
                    $userStore.setPrincipalType(principal.principalType || '')
                }
                // const authoxList=await getUserAuthox($userStore.info?.uid||'')
                //
                // //没有权限，跳转到空页面
                // if (authoxList.length === 0) {
                //     if(to.name === 'authoxEmpty'){
                //         next();
                //     }else {
                //         next(false);
                //         router.push({name: 'authoxEmpty'});
                //     }
                // }


                next()
            } catch (e) {
                next(false);
                router.push({name: 'login'});
            }
        }
    });
}
